import { FormattedMessage } from 'react-intl';
import { Option } from 'react-select';

import {
    DEBIT_CARD_TYPE,
    MANUAL_BANK_TRANSFER_TYPE,
    TRUELAYER_REPAYMENT_TYPE
} from '../EarlyRepaymentHelper';
import { PaymentMethodLogo } from './PaymentMethodLogo';
import styles from './PaymentMethodOption.module.css';
import messages from './SelectPaymentMethod.messages';

export class PaymentMethodOption extends Option {
    renderPaymentMethod(type) {
        const { option, instancePrefix, optionIndex } = this.props;
        return (
            <div
                className={styles.PaymentMethodOption}
                style={option.style}
                role="option"
                aria-label={option.label}
                aria-selected="true"
                onMouseDown={this.handleMouseDown}
                onMouseEnter={this.handleMouseEnter}
                onMouseMove={this.handleMouseMove}
                onTouchStart={this.handleTouchStart}
                onTouchMove={this.handleTouchMove}
                onTouchEnd={this.handleTouchEnd}
                id={instancePrefix + '-option-' + optionIndex}
                title={option.title}
            >
                {type === 'BANK_ACCOUNT' ? (
                    <BankAccountLabel
                        label={option.label}
                        issuer={option.issuer}
                    />
                ) : (
                    <CardLabel
                        cardLastDigits={option.cardLastDigits}
                        issuer={option.issuer}
                    />
                )}
            </div>
        );
    }

    renderManualPaymentMethod() {
        const { option, instancePrefix, optionIndex } = this.props;
        const className = styles.PaymentMethodOption;

        return (
            <div
                className={className}
                style={option.style}
                role="option"
                aria-label={option.label}
                aria-selected="true"
                onMouseDown={this.handleMouseDown}
                onMouseEnter={this.handleMouseEnter}
                onMouseMove={this.handleMouseMove}
                onTouchStart={this.handleTouchStart}
                onTouchMove={this.handleTouchMove}
                onTouchEnd={this.handleTouchEnd}
                id={instancePrefix + '-option-' + optionIndex}
                title={option.title}
            >
                <ManualBankTransferLabel />
            </div>
        );
    }

    renderTruelayerRepayment() {
        const { option, instancePrefix, optionIndex } = this.props;
        const className = styles.PaymentMethodOption;

        return (
            <div
                className={className}
                style={option.style}
                role="option"
                aria-label={option.label}
                aria-selected="true"
                onMouseDown={this.handleMouseDown}
                onMouseEnter={this.handleMouseEnter}
                onMouseMove={this.handleMouseMove}
                onTouchStart={this.handleTouchStart}
                onTouchMove={this.handleTouchMove}
                onTouchEnd={this.handleTouchEnd}
                id={instancePrefix + '-option-' + optionIndex}
                title={option.title}
            >
                <TruelayerLabel />
            </div>
        );
    }

    render() {
        const {
            option: { type }
        } = this.props;

        switch (type) {
            case MANUAL_BANK_TRANSFER_TYPE:
                return this.renderManualPaymentMethod();
            case DEBIT_CARD_TYPE:
            case 'BANK_ACCOUNT':
                return this.renderPaymentMethod(type);
            case TRUELAYER_REPAYMENT_TYPE:
                return this.renderTruelayerRepayment();
        }
    }
}

const CardLabel = ({ cardLastDigits, issuer }) => (
    <div className={styles.labelContainer}>
        <PaymentMethodLogo
            type={DEBIT_CARD_TYPE}
            issuer={issuer}
            logoStyle={styles.icon}
        />
        <FormattedMessage
            {...messages.cardOption}
            values={{ cardLastDigits: cardLastDigits }}
        />
    </div>
);

const BankAccountLabel = ({ label, issuer }) => (
    <div className={styles.labelContainer}>
        <PaymentMethodLogo
            type={DEBIT_CARD_TYPE}
            issuer={issuer}
            logoStyle={styles.icon}
        />
        <FormattedMessage
            {...messages.bankAccountOption}
            values={{ accountNumber: label }}
        />
    </div>
);

const ManualBankTransferLabel = () => (
    <div className={styles.labelContainer}>
        <PaymentMethodLogo
            type={MANUAL_BANK_TRANSFER_TYPE}
            logoStyle={styles.icon}
        />
        <FormattedMessage {...messages.manualPayment} />
    </div>
);

const TruelayerLabel = () => (
    <div className={styles.labelContainer}>
        <PaymentMethodLogo
            type={TRUELAYER_REPAYMENT_TYPE}
            logoStyle={styles.icon}
        />
        <FormattedMessage {...messages.truelayerRepayment} />
        <span className={styles.recommendedTag}>Recommended</span>
    </div>
);
